import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

const StatCard = ({ label, value, testid }) => (
  <div className="bg-white border border-[#C5A059]/25 p-7 shadow-[0_8px_32px_rgba(0,0,0,0.04)]" data-testid={testid}>
    <p className="text-[10px] tracking-[0.3em] uppercase text-[#9E7B3A] mb-3">{label}</p>
    <p className="font-serif text-4xl font-light text-[#1A1A1A]">{value}</p>
  </div>
);

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    api.get("/admin/stats").then(({ data }) => setStats(data)).catch(() => {});
    api.get("/admin/orders").then(({ data }) => setRecent(data.slice(0, 5))).catch(() => {});
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-serif text-3xl md:text-4xl font-light mb-2">Dashboard</h1>
      <p className="text-sm text-[#4A4A4A] mb-10">Your store at a glance.</p>

      <div className="grid grid-cols-2 lg:grid-cols-5 gap-5 mb-14">
        <StatCard label="Revenue" value={stats ? `$${stats.revenue.toFixed(2)}` : "—"} testid="stat-revenue" />
        <StatCard label="Profit" value={stats ? `$${stats.profit.toFixed(2)}` : "—"} testid="stat-profit" />
        <StatCard label="Orders" value={stats ? stats.orders : "—"} testid="stat-orders" />
        <StatCard label="To Pack" value={stats ? stats.to_pack : "—"} testid="stat-to-pack" />
        <StatCard label="Waitlist" value={stats ? stats.subscribers : "—"} testid="stat-subscribers" />
      </div>

      <div className="flex items-center justify-between mb-5">
        <h2 className="font-serif text-2xl font-light">Recent Orders</h2>
        <Link to="/admin/orders" data-testid="view-all-orders-link"
          className="text-xs tracking-[0.2em] uppercase text-[#9E7B3A] hover:text-[#1A1A1A] transition-colors duration-300">
          View All
        </Link>
      </div>
      {recent.length === 0 ? (
        <p className="text-sm text-[#4A4A4A] bg-white border border-[#C5A059]/25 p-8" data-testid="no-orders-message">
          No orders yet. Create your first order from the Orders page.
        </p>
      ) : (
        <div className="bg-white border border-[#C5A059]/25 divide-y divide-[#C5A059]/15" data-testid="recent-orders-list">
          {recent.map((o) => (
            <div key={o.id} className="flex items-center justify-between px-6 py-4">
              <div>
                <p className="text-sm font-medium">{o.order_number}</p>
                <p className="text-xs text-[#4A4A4A]">{o.customer?.name}</p>
              </div>
              <div className="text-right">
                <p className="text-sm">${o.total?.toFixed(2)}</p>
                <p className="text-xs text-[#9E7B3A]">{o.status}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
